import type { Citation } from '../types/api';

// Derive a page title from a doc file path: basename, drop `.md`, turn
// separators into spaces, and title-case. KB citations carry their own title.
export function formatPageTitle(filePath: string): string {
  const name = filePath.split(/[/\\]/).pop()?.replace('.md', '') ?? filePath;
  return name.replace(/[-_]/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}

// The label shown on a citation chip — page title for docs, article title for KB.
export function chipLabel(citation: Citation): string {
  return citation.source === 'kb' && citation.title
    ? citation.title
    : formatPageTitle(citation.file_path);
}
